// JS
require('./init.js');
require('slick-carousel');
// Sass
require('./../sass/index.sass');
